import { render, staticRenderFns } from "./SettingsBorderRadius.vue?vue&type=template&id=a32a3a0a&"
import script from "./SettingsBorderRadius.vue?vue&type=script&lang=js&"
export * from "./SettingsBorderRadius.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports